import * as yup from 'yup';

export const emailField = yup.string().email().required();
export const passwordField = yup.string().min(8).required();

export const emailAndPasswordSchema = yup.object({
  email: emailField,
  password: passwordField,
});
